export default __webpack_public_path__ + "static/media/ErezBoniel.14155664.webp";